import React, { useState, useEffect } from "react";
import { Form, Button, Alert, Modal, Spinner, Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import authConfig from "../../authConfig";
import { useSelector, useDispatch } from "react-redux";
import { setLoginState, logout } from "../../redux/authSlice";

const AuthLogin = ({ onLogin }) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [confirmpassword, setConfirmpassword] = useState("");
    const [error, setError] = useState("");
    const [showForgot, setShowForgot] = useState(false);
    const [forgotUsername, setForgotUsername] = useState("");
    const [forgotMessage, setForgotMessage] = useState("");
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Use Redux login state
    const isLoggedIn = useSelector(state => state.auth.isLoggedIn);

    const [forgotPassword, setForgotPassword] = useState(null);

    async function updatereduxloginstate() {
        const res = await axios
            .get(authConfig.api.urls.getAuthStatus, { withCredentials: true });
        if (res && res.data.isAuthenticated) {
            dispatch(setLoginState({
                isLoggedIn: true,
                user: {
                    username: res.data.username,
                    memberId: res.data.memberId,
                    fullname: res.data.fullname,
                    roles: res.data.roles,
                }
            }));
        } else {
            dispatch(setLoginState({ isLoggedIn: false, user: null }));
        }
    }
    useEffect(() => {
        updatereduxloginstate();
        setLoading(false);
    }, [dispatch]);

    useEffect(() => {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        if (params) {
            const forgotPasswordValue = params.get('forgotpassword');
            const emailValue = params.get('email');

            setForgotPassword(forgotPasswordValue);
            setUsername(emailValue);
        }
    }, [window.location]);

    

    useEffect(() => {
        if (isLoggedIn) {
            navigate("/membersarea"); // Change "/" to your desired redirect route
        }
    }, [isLoggedIn, navigate]);

    

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (forgotPassword == null) {
            setError("");
            try {
                const res = await axios.post(
                    authConfig.api.urls.getAuthLogin,
                    { username, password },
                    { withCredentials: true }
                );
                dispatch(setLoginState({
                    isLoggedIn: true,
                    user: res.data.user || { username }
                }));
                updatereduxloginstate();
                if (onLogin) onLogin();
                setError("");
            } catch (err) {
                setError("Invalid username or password.");
                dispatch(setLoginState({ isLoggedIn: false, user: null }));
            }
        } else {
            try {
                if (password === confirmpassword) {
                    const res = await axios.post(
                        authConfig.api.urls.getAuthChangePassword,
                        { username, password, token: forgotPassword },
                        { withCredentials: true }
                    );
                    dispatch(setLoginState({
                        isLoggedIn: true,
                        user: res.data.user || { username }
                    }));
                    updatereduxloginstate();
                    if (onLogin) onLogin();
                    setError("");
                } else {
                    setError("Passwords do not match.");
                }
            } catch (err) {
                console.log(err);
                setError("Invalid username or password reset token expired.");
                dispatch(setLoginState({ isLoggedIn: false, user: null }));
            }
        }
    };

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        setForgotMessage("");
        try {
            await axios.post(
                authConfig.api.urls.getAuthForgotPassword,
                { username: forgotUsername },
                { withCredentials: true }
            );
            setForgotMessage("If the username exists, a password reset link has been sent.");
        } catch {
            setForgotMessage("Error sending reset link.");
        }
    };

    if (loading) {
        return (
            <Container className="mt-5 text-center">
                <Spinner animation="border" />
            </Container>
        );
    }

    if (isLoggedIn) {
        //return null; // Or a spinner/redirect message if you prefer
    }

    return (
        <Container>
            <Row className="justify-content-md-center">
                <Col md={5}>
                    <h2 className="mt-4 mb-3">{forgotPassword ? "Reset Password" : "Login"}</h2>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="loginUsername" className="mb-3">
                            <Form.Label>Username</Form.Label>
                            <Form.Control
                                type="text"
                                value={username}
                                autoComplete="username"
                                onChange={e => setUsername(e.target.value)}
                                required
                                disabled={forgotPassword == null ? false : true}
                            />
                        </Form.Group>
                        <Form.Group controlId="loginPassword" className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                required
                            />
                        </Form.Group>
                        {forgotPassword == null ? (<></>) : (
                            <Form.Group controlId="confirmloginPassword" className="mb-3">
                                <Form.Label>Confirm Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    value={confirmpassword}
                                    onChange={e => setConfirmpassword(e.target.value)}
                                    required
                                />
                            </Form.Group>
                        )}

                        {error && <Alert variant="danger">{error}</Alert>}
                        {forgotPassword == null ? (
                            <>
                                <Button type="submit" variant="success" className="w-100 mt-2">
                                    Login
                                </Button>
                                <div className="text-end mt-2">
                                    <Button
                                        variant="link"
                                        size="sm"
                                        onClick={() => setShowForgot(true)}
                                        style={{ padding: 0 }}
                                    >
                                        Forgot password?
                                    </Button>
                                </div>
                            </>
                        ) : (
                            <Button type="submit" variant="success" className="w-100 mt-2">
                                Change Password
                            </Button>
                        )}
                    </Form>
                </Col>
            </Row>
            <Modal show={showForgot} onHide={() => setShowForgot(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Forgot Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleForgotPassword}>
                        <Form.Group controlId="forgotUsername" className="mb-3">
                            <Form.Label>Username</Form.Label>
                            <Form.Control
                                type="text"
                                value={forgotUsername}
                                onChange={e => setForgotUsername(e.target.value)}
                                required
                            />
                        </Form.Group>
                        {forgotMessage && <Alert variant="info">{forgotMessage}</Alert>}
                        <Button type="submit" variant="primary" className="w-100">
                            Send Reset Link
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </Container>
    );
};

export default AuthLogin;